import { fbt } from 'fbtee'
import { getRegion, EVERYWHERE_REGION_ID } from '@shared/regions'

/**
 * Display name for a region id. Anything we can't resolve reads as
 * "Everywhere" rather than blank — there is no unconfigured state to surface.
 */
export function regionLabel(regionId: string): string {
  if (regionId !== EVERYWHERE_REGION_ID) {
    const region = getRegion(regionId)
    if (region) return region.name
  }
  return fbt(
    'Everywhere',
    'Location label when the user is browsing events from every region',
  ).toString()
}
